import React from 'react';
import { HeroPanel } from './components/HeroPanel';
import { ManifestoPanel } from './components/ManifestoPanel';
import { ProductSection } from './components/ProductSection';
import { FooterPanel } from './components/FooterPanel';
export type Product = {
  id: string;
  name: string;
  description: string;
  imageUrl: string;
  vorteile: {
    icon: string;
    text: string;
  }[];
  usps: string[];
  idealFor: string[];
};
const products: Product[] = [{
  id: 'p01',
  name: 'Absackwaage mit Rohr-Metalldetektor',
  description: 'Höchste Präzision bei der Abfüllung kombiniert mit zuverlässiger Fremdkörpererkennung. Die integrierte Lösung für maximale Produktsicherheit in der Schüttgutindustrie.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/86hUSs23fgp8aEtMFDnZb8/Absackwaage_MiNexx-Minebea[41]_TR.png',
  vorteile: [{
    icon: 'ShieldCheck',
    text: 'Höchste Produktsicherheit'
  }, {
    icon: 'Maximize',
    text: 'Kompakte Bauweise'
  }, {
    icon: 'Zap',
    text: 'Schnelle Abfüllung'
  }, {
    icon: 'Settings',
    text: 'Einfache Bedienung'
  }, {
    icon: 'Layers',
    text: 'Modulares System'
  }, {
    icon: 'Activity',
    text: 'Präzise Verwiegung'
  }],
  usps: ['Integrierter Rohr-Metalldetektor', 'Staubfreie Abfüllung', 'Eichfähige Ausführung', 'Hygienic Design'],
  idealFor: ['Pulver & Granulate', 'Lebensmittel', 'Chemie']
}, {
  id: 'p02',
  name: 'Hygienewaage',
  description: 'Kompromissloses Hygienic Design für anspruchsvolle Produktionsumgebungen. Leicht zu reinigen, extrem robust und hochpräzise für den Nassbereich.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/xj2kvXu5mDu2AfSNFnAd17/Hygienewaage_MiNexx-Minebea[60]_TR.png',
  vorteile: [{
    icon: 'Droplets',
    text: 'Optimale Nassreinigung'
  }, {
    icon: 'Shield',
    text: 'Schutzart IP69K'
  }, {
    icon: 'CheckCircle2',
    text: 'EHEDG konform'
  }, {
    icon: 'Activity',
    text: 'Schnelle Anzeige'
  }, {
    icon: 'Cpu',
    text: 'Smarte Auswertung'
  }, {
    icon: 'Maximize',
    text: 'Ergonomisches Design'
  }],
  usps: ['Offenes Design ohne Schmutzecken', 'Elektropolierte Oberflächen', 'Schnelle und sichere Reinigung', 'Robuste Edelstahlkonstruktion'],
  idealFor: ['Fleischverarbeitung', 'Pharma', 'Molkereien']
}, {
  id: 'p03',
  name: 'IBC-Wiegesystem',
  description: 'Sicheres und genaues Verwiegen von Intermediate Bulk Containern. Robuste Konstruktion für den rauen Industriealltag mit intelligenten Auswerteelektroniken.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/jymT3y7PdGXtft53VDNCMZ/IBC_Wagesystem_MiNexx-Minebea[35]_TR.png',
  vorteile: [{
    icon: 'Package',
    text: 'IBC-optimiert'
  }, {
    icon: 'Shield',
    text: 'Robuste Konstruktion'
  }, {
    icon: 'Zap',
    text: 'Schnelle Erfassung'
  }, {
    icon: 'Activity',
    text: 'Hohe Genauigkeit'
  }, {
    icon: 'Lock',
    text: 'Sicherer Stand'
  }, {
    icon: 'Settings',
    text: 'Flexible Integration'
  }],
  usps: ['Passgenau für Standard-IBCs', 'Integrierter Anfahrschutz', 'ATEX-Ausführungen verfügbar', 'Hohe Überlastfähigkeit'],
  idealFor: ['Flüssigkeiten', 'Chemikalien', 'Logistik']
}, {
  id: 'p04',
  name: 'Mobile Waagen',
  description: 'Maximale Flexibilität in der Produktion. Bringen Sie die Waage zum Produkt, nicht umgekehrt. Kabelloser Betrieb und ergonomisches Handling.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/56YatduGbYHj7pacD8cRea/Mobile_Waage_MiNexx-Minebea2[87]_TR.png',
  vorteile: [{
    icon: 'Move',
    text: 'Volle Mobilität'
  }, {
    icon: 'Battery',
    text: 'Langer Akkubetrieb'
  }, {
    icon: 'Maximize',
    text: 'Kompakte Abmessungen'
  }, {
    icon: 'Wifi',
    text: 'WLAN-Anbindung'
  }, {
    icon: 'Shield',
    text: 'Industrietauglich'
  }, {
    icon: 'Activity',
    text: 'Präzise Ergebnisse'
  }],
  usps: ['Integrierter Hochleistungsakku', 'Leichtlaufrollen mit Feststeller', 'Kabellose Datenübertragung', 'Ergonomischer Schiebegriff'],
  idealFor: ['Wareneingang', 'Kommissionierung', 'Flexible Produktion']
}, {
  id: 'p05',
  name: 'Prozessstation',
  description: 'Das Herzstück Ihrer automatisierten Verwiegung. Modulare Prozessstation für komplexe Dosier- und Mischanwendungen mit voller Integration in Ihr ERP-System.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/8SwayYVgvQLyzsm3WV6DCt/Prozessstation_MiNexx-Minebea[23]_TR.png',
  vorteile: [{
    icon: 'Factory',
    text: 'Prozessintegration'
  }, {
    icon: 'Cpu',
    text: 'Smart Control'
  }, {
    icon: 'Layers',
    text: 'Modularer Aufbau'
  }, {
    icon: 'Activity',
    text: 'Hochpräzise Dosierung'
  }, {
    icon: 'Network',
    text: 'ERP-Ready'
  }, {
    icon: 'ShieldCheck',
    text: 'Prozesssicherheit'
  }],
  usps: ['Vollständige Automatisierung', 'Rezepturverwaltung integriert', 'Nahtlose ERP/MES Anbindung', 'Kundenspezifische Anpassung'],
  idealFor: ['Mischprozesse', 'Dosieranlagen', 'Automatisierung']
}];
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-800 selection:bg-hoefelmeyer-green selection:text-petrol-dark" data-id="element-0">
      <main data-id="element-1">
        <HeroPanel data-id="element-2" />
        <ManifestoPanel data-id="element-3" />

        {/* Product Showcase Header */}
        <div className="w-full bg-white pt-32 pb-16 relative z-10" data-id="element-4">
          <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-5">
            <div className="flex items-center gap-4 mb-6" data-id="element-6">
              <span className="text-hoefelmeyer-green font-bold text-xl" data-id="element-7">
                02
              </span>
              <div className="h-px w-12 bg-hoefelmeyer-green" data-id="element-8"></div>
              <span className="text-sm uppercase tracking-widest text-slate-500 font-medium" data-id="element-9">
                Portfolio
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-petrol" data-id="element-10">
              Gemeinsame Lösungen.
            </h2>
          </div>
        </div>

        {/* Products */}
        <div className="relative bg-white" data-id="element-11">
          {products.map((product, index) => <ProductSection key={product.id} product={product} index={index} data-id="element-12" />)}
        </div>
      </main>
      <FooterPanel data-id="element-13" />
    </div>;
}